import { type FunctionComponent } from 'react';
import { ReactComponent as BlueStripSVG } from '../../assets/icons/mevo/medicine/tarjaazul.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineBlueStripIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={BlueStripSVG} variantPlaces={[]} {...props} />;
};

export default MedicineBlueStripIcon;
